import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class LoaderService {
    public isSomethingLoading = 0;
    public observer: EventEmitter<number> = new EventEmitter();

    constructor() { }

    public addLoader() {
        this.isSomethingLoading++;
        this.observer.emit(this.isSomethingLoading);
    }

    public resetLoader() {
        this.isSomethingLoading = 0;
        this.observer.emit(0);
    }

    public removeLoader() {
        this.isSomethingLoading--;
        this.observer.emit(this.isSomethingLoading);
    }

    verifyLoader() { }
}
